export default "__VITE_ASSET__DGX2Qoy7__"